import { render, staticRenderFns } from "./studentRoyaltyDetails.vue?vue&type=template&id=bb5e3f20&scoped=true"
import script from "./studentRoyaltyDetails.vue?vue&type=script&lang=js"
export * from "./studentRoyaltyDetails.vue?vue&type=script&lang=js"
import style0 from "./studentRoyaltyDetails.vue?vue&type=style&index=0&id=bb5e3f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5e3f20",
  null
  
)

export default component.exports